// removed by extract-text-webpack-plugin
module.exports = {"prompt":"_36LE8","people":"_1Qxvt","col-info":"_1-UDq","messages":"U77k5","col-feedback":"SZodW","col-btn-feedback":"_20NOM","btn-feedback":"_233yC","link-feedback":"_34yjX","grey-cross":"_2Gr7u","prompt-text":"_3IIi9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Prompt/GiveFeedback/GiveFeedback.scss
// module id = ./src/components/Prompt/GiveFeedback/GiveFeedback.scss
// module chunks = 4